export function getNormalizedSafeUrl(url: string): string {
  if (!url) {
    return url;
  }

  if (url.endsWith('.jfif') || url.includes('.jfif-')) {
    return url.replace(/-lg\.webp$|-md\.webp$|-sm\.webp$|-webp$/i, '');
  }
  return url;
}
